import { render } from "./MoneyballStickRank.vue?vue&type=template&id=9cc8990a"
import script from "./MoneyballStickRank.vue?vue&type=script&lang=js"
export * from "./MoneyballStickRank.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__